import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=d629be62"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d629be62')) {
      api.createRecord('d629be62', component.options)
    } else {
      api.reload('d629be62', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=d629be62", function () {
      api.rerender('d629be62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/editor.vue"
export default component.exports